import React, { useContext, useEffect, useState } from "react";
import { ToasterContext } from "../../context/ToasterContext";
import "./index.css";

/*
  Place <ToastNotification /> once at the app root inside <ToasterProvider>.
  Trigger it from anywhere via the useToaster hook:
    const { showToast } = useToaster();
    showToast("Some message", "warning", true);
  severity = "success" | "info" | "warning" | "error"
*/
const ToastNotification = () => {
  const { toaster, setToaster } = useContext(ToasterContext);
  const { isOpen, message, severity, autoClose } = toaster;
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (isOpen && !isHovered && autoClose) {
      const timer = setTimeout(() => {
        setToaster((prev) => ({ ...prev, isOpen: false }));
      }, 2600);

      return () => clearTimeout(timer);
    }
  }, [isOpen, isHovered, autoClose, setToaster]);

  const handleClose = () => {
    setToaster((prev) => ({ ...prev, isOpen: false, autoClose: true }));
    setIsHovered(false);
  };

  if (!isOpen) return null;

  const severityClass = ["success", "info", "warning", "error"].includes(severity)
    ? severity
    : "info";

  return (
    <div className="toast-snackbar" role="presentation">
      <div
        className={`toast-alert toast-alert--${severityClass}`}
        role="alert"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <span className="toast-alert__message">{message}</span>
        <button
          type="button"
          className="toast-alert__close"
          onClick={handleClose}
          aria-label="Close"
          data-testid="toast-close"
        >
          &times;
        </button>
      </div>
    </div>
  );
};

export default ToastNotification;
